<ng-template #coreInput>
    <div
        class="form-group {{ parentClass }}"
        [ngClass]="{
            'has-basic-label': basicLabel,
            'has-float-label': floatLabel,
            'has-inner-label': !floatLabel && label && innerLabel,
            'label-rows-2': labelRows === 2,
            disabled: disabled,
            invalid: showErrorMessage()
        }"
    >
        <label
            *ngIf="label && !floatLabel && !innerLabel"
            [for]="name"
            [ngClass]="[
                basicLabel ? 'basic-label' : '',
                labelClass ? labelClass : '',
                showErrorMessage() ? 'text-danger' : ''
            ]"
            >{{ label }}
        </label>
        <div
            class="input-group"
            [ngClass]="{
                'is-focused': isFocused,
                'is-invalid': showErrorMessage(),
                'is-focused-or-filled': isFocusedOrFilled()
            }"
        >
            <textarea
                #inputElement
                [ngClass]="inputClass"
                [id]="name"
                [placeholder]="placeholder ? placeholder : ' '"
                [ngModel]="model"
                [attr.rows]="rows"
                [attr.cols]="cols"
                [style.resize]="resize"
                [attr.maxlength]="maxLength"
                [attr.readonly]="readOnly || undefined"
                [ngModelOptions]="ngModelOptions"
                [disabled]="disabled"
                (focus)="handleFocusChange(true)"
                (blur)="handleFocusChange(false)"
                (keypress)="handleKeypress($event)"
                (ngModelChange)="handleChangeCustom($event)"
            ></textarea>
            <ng-content></ng-content>
        </div>
        <label
            *ngIf="label && (floatLabel || innerLabel)"
            [for]="name"
            [ngClass]="{
                'float-label': floatLabel,
                'inner-label': !this.floatLabel && this.label && this.innerLabel,
                'basic-label': basicLabel,
                'text-danger': showErrorMessage(shouldValidate())
            }"
        >
            {{ label }}
        </label>
    </div>
</ng-template>

<div class="lsq-textarea">
    <ng-container *ngTemplateOutlet="coreInput"> </ng-container>
    <h6 class="input-error-message text-uppercase font-weight-bold" *ngIf="showErrorMessage()">
        {{ getErrorMessage() }}
    </h6>
</div>
